$(document).ready(function(){


    $(document).on('mouseenter', '.product-image img', function() {
      const hoverImg = $(this).attr('hover-img');
      if (hoverImg) {
        $(this).attr('data-original-src', $(this).attr('src'));
        $(this).attr('src', hoverImg);
      }
    }).on('mouseleave', '.product-image img', function() {
      const originalSrc = $(this).attr('data-original-src');
      if (originalSrc) {
        $(this).attr('src', originalSrc);
      }
    });


   $('.ques_answer_col label').click(function() {
       
        var $accordion = $(this).parents('.ques_answer_col').find('.answer_description');
        var height_accordion = $(this).parents('.ques_answer_col').find('.faq_answer_content').height();
    
        if ($accordion.height() > 0)
        {
            $accordion.css('height', '0');
            $(this).find('.plus').css('display','flex');
            $(this).find('.minus').hide();
        }
        else
        {
            $accordion.css('height', height_accordion + 'px');
            $(this).find('.plus').hide(); 
            $(this).find('.minus').css('display','flex');
        }
    });


  $('.faqs_btn a').click(function(event){
      event.preventDefault(); 
      
      var current_btn = $(this).attr('href');
      current_btn = current_btn.replace( /#/, "" );

      var $targetElement = $('.faq_qu_ans_wrap h2[id="'+current_btn+'"]');
      
      if ($targetElement.length) 
      {
          $('html, body').stop().animate({
              scrollTop: ($targetElement.offset().top - 130)
          }, 1000);
      }
      else 
      {
          console.error("Target element not found for href: " + current_btn);
      }
  });


  // =============================== Product Accordion =======================

  $('.meta_accordion_col label').click(function() {
       
        var accordion_content = $(this).parents('.meta_accordion_col').find('.meta_accordion_content');
        var product_desc_height = $(this).parents('.meta_accordion_col').find('.meta_fields_description').height();

        if (accordion_content.height() > 0)
        {
            accordion_content.css('height', '0');
            $(this).find('.accordion_plus').show();
            $(this).find('.accordion_minus').hide();
        } 
        else
        {
            accordion_content.css('height', product_desc_height + 'px');
            $(this).find('.accordion_plus').hide(); 
            $(this).find('.accordion_minus').show();
        }
    });

  // ===================== All BLog Articles page pagination ==========================

  var items = $(".articels_row .articles_column");
  var numItems = items.length;
  var perPage = 4;

  function initializePagination()
  {
      items.slice(perPage).hide();
      $('.custom_blog_pagination').pagination({
          items: numItems,
          itemsOnPage: perPage,
          prevText: "&laquo;",
          nextText: "&raquo;",
          onPageClick: function (pageNumber) {
              var showFrom = perPage * (pageNumber - 1);
              var showTo = showFrom + perPage;
              items.hide().slice(showFrom, showTo).show();
          }
      });
  }

  initializePagination();
  
  $('.all_manage_blog_tab label').click(function(){
      var selected_blog = $(this).attr('data-heading');
      var filteredItems = $('.articles_column[data-blog="'+selected_blog+'"]');
      
      items.hide();
      filteredItems.show();

      numItems = filteredItems.length;
      
      filteredItems.slice(perPage).hide();
      $('.custom_blog_pagination').pagination('destroy');
      $('.custom_blog_pagination').pagination({
          items: numItems,
          itemsOnPage: perPage,
          prevText: "&laquo;",
          nextText: "&raquo;",
          onPageClick: function (pageNumber) {
              var showFrom = perPage * (pageNumber - 1);
              var showTo = showFrom + perPage;
              filteredItems.hide().slice(showFrom, showTo).show();
          }
      });
  });

  
});